import createAction from '../../../../utils/redux-helpers/createAction';

const handler = (state, { data }) => state.set('selectedDeliveryZone', data);

export const setDeliveryZoneData = createAction({
  action: ['setDeliveryZoneData', 'data'],
  handler,
});
